export default "__VITE_ASSET__f7d1a23d__"